/**
 * MEMANDOCON · Card Pool 2026
 * Database completo di 480 didascalie WDYM-style fornite dall'utente.
 *
 * Struttura:
 *   - base: 40 carte per TOV × 3 TOV = 120 carte → entrano VERBATIM nel mazzo
 *     finale (le 40 del TOV scelto dal cliente).
 *   - mop: 10 Match or Pass per TOV × 3 = 30 carte → mostrate al cliente
 *     allo step 3, le matchate vanno verbatim nel mazzo.
 *   - expansion: 110 espansioni per TOV × 3 = 330 carte → usate dal backend
 *     come STYLE REFERENCE nel prompt (Claude pesca samples da qui per
 *     produrre le ~50 AI cards sul questionario del cliente).
 *
 * Totale: 480 carte universali (funzionano su qualsiasi foto del festeggiato).
 *
 * Espone window.MEMANDOCON_POOL così caption-it-briefing-v2.js può leggerle.
 */
(function () {
  'use strict';

  window.MEMANDOCON_POOL = {
    base: {
      serio: [
        "Il momento esatto in cui ha capito che stava diventando adulto/a.",
        "Vent'anni di esperienze. Nessuna delle quali lo/la ha cambiato davvero.",
        "La faccia di chi ha già vissuto tutto questo — e lo rifarà.",
        "Quando realizzi che sei tu quello/a responsabile adesso.",
        "L'espressione di chi porta tutto sulle spalle e non lo dice a nessuno.",
        "Quello/a che non cambia mai, qualunque cosa succeda.",
        "Il momento prima di dire qualcosa di importante. Per sempre.",
        "La versione di [NOME] che pochi hanno il privilegio di vedere.",
        "Quando capisci che certe persone non le trovi due volte.",
        "La faccia di chi ha già perdonato — senza che nessuno glielo abbia chiesto.",
        "Il giorno in cui ha deciso di smettere di aspettare il momento giusto.",
        "Quello/a che non ha bisogno di spiegare niente — si capisce già tutto.",
        "La versione di [NOME] che apparirà nei ricordi tra dieci anni.",
        "Quando guardi indietro e ti accorgi che è andata bene comunque.",
        "L'espressione di chi sa esattamente dove sta andando — anche se non lo dice.",
        "Il momento in cui smette di fingere che vada tutto bene.",
        "Quello/a che rimane quando tutti gli altri se ne sono già andati.",
        "La faccia di chi non chiede mai niente — e per questo merita tutto.",
        "Quando realizzi che la persona più importante nella stanza sei tu.",
        "L'espressione di chi ha già visto abbastanza per non stupirsi più — ma si stupisce ancora.",
        "Il momento esatto in cui qualcosa cambia per sempre.",
        "Quello/a che non ha bisogno di far rumore per farsi sentire.",
        "La faccia di chi porta avanti le cose anche quando non ne ha voglia.",
        "Quando sai già come finirà — e vai avanti lo stesso.",
        "L'istante prima che diventi la storia che raccontiamo per anni.",
        "Quello/a che c'è sempre — anche quando non ci si aspetta che ci sia.",
        "La faccia di chi ha imparato tutto nel modo più difficile possibile.",
        "Il momento in cui smette di chiedere il permesso.",
        "Quello/a che non dimentichi — anche se non sai spiegare perché.",
        "La versione di [NOME] che esiste solo nei ricordi di chi c'era.",
        "Quando sai già che questo momento lo ricorderai.",
        "L'espressione di chi ha già dato tutto — e trova ancora qualcosa da dare.",
        "Quello/a che ti manca ancora prima che se ne vada.",
        "La faccia di chi ha capito che non serve correre — arriva sempre.",
        "Il momento in cui smette di essere un ragazzo/una ragazza e diventa [NOME].",
        "Quello/a che non si lamenta — anche quando avrebbe tutto il diritto.",
        "La faccia di chi ha costruito qualcosa che durerà.",
        "Quando le parole non bastano — e lo sa già.",
        "L'espressione di chi porta la stanza con sé ovunque vada.",
        "Il momento in cui si capisce perché tutti lo/la vogliono bene."
      ],
      educato: [
        "Quando dici 'arrivo subito' ma sei ancora in pigiama.",
        "La faccia di chi ha già deciso ma aspetta che lo capiscano gli altri.",
        "Io quando faccio finta di aver capito le istruzioni.",
        "Il piano era perfetto. Poi è entrato/a [NOME].",
        "Quando stai per dire una cosa e realizzi che è meglio non dirla.",
        "La mia espressione quando mi chiedono se sono pronto/a.",
        "Quello/a che arriva sempre in ritardo con la scusa migliore del gruppo.",
        "Quando il barista ti guarda e sa già cosa ordini senza che tu apra bocca.",
        "La faccia di chi dice 'non mangio molto' e poi finisce tutto.",
        "Io il lunedì mattina vs io il venerdì sera.",
        "Quando qualcuno ti chiede come mai sei così stanco/a e non sai da dove iniziare.",
        "La faccia di chi non guarda il Grande Fratello ma sa tutto.",
        "Quando fai finta di non sentire la sveglia per la terza volta.",
        "Quello/a che porta la giacca impermeabile in agosto 'per sicurezza'.",
        "La mia faccia quando mi dicono che c'è ancora un'ora di riunione.",
        "Quando stai cercando le parole giuste e non ne trovi nessuna di adatta.",
        "Io ogni volta che apro il frigo sperando che sia cambiato qualcosa.",
        "La faccia di chi ha già sentito questa storia — ma la lascia raccontare lo stesso.",
        "Quando dici 'solo cinque minuti' e passano due ore.",
        "Quello/a che sorride sempre — anche quando non dovrebbe.",
        "La mia espressione quando il piano funziona per caso.",
        "Quando arrivi per ultimo/a ma fai finta di essere puntuale.",
        "La faccia di chi sa già come andrà a finire — e aspetta paziente.",
        "Io quando qualcuno mi chiede di fare una cosa 'veloce'.",
        "Quello/a che dice 'non mi interessa' e poi ci pensa tutta la notte.",
        "Quando realizzi che la serata stava andando troppo bene.",
        "La faccia di chi ha appena detto sì a qualcosa che non avrebbe dovuto.",
        "Io quando cerco di sembrare normale davanti a persone nuove.",
        "Quello/a che porta energia in ogni stanza — anche quando non vuole.",
        "Quando il GPS dice di girare e tu hai già girato.",
        "La faccia di chi sta aspettando la fine del discorso per dire la sua.",
        "Io ogni volta che apro WhatsApp e ci sono 47 messaggi non letti.",
        "Quando stai per rispondere e realizzi che è meglio non farlo.",
        "La faccia di chi ha già perso la pazienza — ma la sta cercando ancora.",
        "Quello/a che dice sempre 'ultima volta' — ed è la quinta.",
        "Quando fai la cosa giusta ma nessuno se ne accorge.",
        "La mia faccia quando mi fanno una domanda di cui conosco già la risposta.",
        "Quello/a che non riesce a dire no — e lo sa benissimo.",
        "Quando la serata doveva essere tranquilla e invece eccoci qua.",
        "La faccia di chi ha tutto sotto controllo tranne la situazione attuale."
      ],
      spinto: [
        "L'espressione di chi sa cose che non dovrebbe sapere.",
        "Io dopo il secondo drink quando dicevo che non bevevo.",
        "La faccia di chi ha già deciso — e la decisione è pessima.",
        "Quando dici 'stasera sto tranquillo/a' e il giorno dopo ti svegli altrove.",
        "Quello/a che nega tutto davanti a testimoni oculari.",
        "La mia faccia quando mi chiedono con chi ero ieri sera.",
        "Io ogni volta che dico 'giuro che questa è l'ultima'.",
        "Quando il piano era non farlo sapere a nessuno — e adesso siamo qui.",
        "La faccia di chi ha una storia ma non può raccontarla stasera.",
        "Quello/a che torna a casa alle 6 con la scusa dell'after.",
        "Quando stai per fare una cosa di cui ti pentirai domani mattina — e lo sai già.",
        "La mia espressione quando qualcuno mi chiede di spiegare quella serata.",
        "Io quando faccio finta che il mio telefono non abbia la cronologia.",
        "Quello/a che dice 'è una situazione complicata' da tre anni.",
        "Quando realizzi che quella persona ti sta ancora guardando.",
        "La faccia di chi ha mentito così bene che ci crede anche lui/lei.",
        "Io il sabato mattina vs io il sabato sera vs io la domenica mattina.",
        "Quando il gruppo sa tutto ma fa finta di non sapere niente.",
        "La mia faccia quando mi chiedono se ho 'fatto il bravo/a' in vacanza.",
        "Quello/a che ha una risposta per tutto — tranne per spiegare quella notte.",
        "Quando stai cercando di sembrare innocente e non ci riesci per niente.",
        "La faccia di chi ha già visto questo film e sa com'è andata.",
        "Io quando qualcuno tira fuori quella storia davanti alle persone sbagliate.",
        "Quello/a che conosce qualcuno in ogni città — e non spiega mai come.",
        "Quando dici 'non sono geloso/a' per la settima volta in dieci minuti.",
        "La mia espressione quando il piano B non esiste ma il piano A è già fallito.",
        "Io ogni volta che apro la chat e vedo 'sta scrivendo...' per troppo tempo.",
        "Quello/a che non ricorda la serata ma è quello/a con più foto nel telefono.",
        "Quando qualcuno ti chiede perché ridi e non puoi spiegarlo in questo contesto.",
        "La faccia di chi è sobrio/a — secondo lui/lei.",
        "Io quando cerco di essere discreto/a e fallisco completamente.",
        "Quello/a che ha detto 'è una cosa seria' e dopo una settimana eccoci qua.",
        "Quando stai per dire la verità e poi dici 'lascia stare'.",
        "La mia faccia quando mi rendo conto che tutti sanno già tutto.",
        "Quello/a che 'non usa i social' ma sa tutto di tutti.",
        "Quando la serata doveva finire alle undici — buonanotte.",
        "Io quando mi chiedono di commentare una mia scelta di vita recente.",
        "La faccia di chi ha già un piano — e il piano è discutibile.",
        "Quello/a che nega, nega, nega — poi ammette tutto in un vocale.",
        "Quando sai già che questa storia finirà in una carta Memandocon."
      ]
    },
    mop: {
      serio: [
        "Il momento in cui ha smesso di essere invincibile — ed è diventato/a umano/a.",
        "Quello/a che porta ancora dentro qualcosa che non ha mai detto a voce alta.",
        "Quando guardi [NOME] e pensi: quanto ho rischiato di non conoscerti.",
        "La faccia di chi ha perso qualcosa che non ha mai nominato.",
        "Quello/a che sorride — e tu sai già che non è tutto lì.",
        "Il momento in cui ha realizzato che certe cose non tornano.",
        "La versione di [NOME] che esiste solo quando è davvero stanco/a.",
        "Quello/a che porta ancora dentro una versione di sé che non mostra più.",
        "Quando sai che quella persona ha attraversato qualcosa — senza che te lo abbia mai detto.",
        "La faccia di chi ha imparato a stare bene — ma sa ancora com'era prima."
      ],
      educato: [
        "Quando dici una cosa seria e tutti ridono — e non sai se è un complimento.",
        "La faccia di chi stava cercando di fare bella figura e ha fatto l'opposto.",
        "Io quando mi chiedono di fare una cosa semplice davanti a tutti e non riesco.",
        "Quello/a che porta sempre la situazione un gradino sopra il necessario.",
        "Quando realizzi che stavi facendo quella faccia da venti minuti.",
        "La faccia di chi ha capito la battuta — tre minuti dopo.",
        "Io quando qualcuno mi dice 'non ti preoccupare' e mi preoccupo il doppio.",
        "Quello/a che porta il dramma anche nelle situazioni completamente normali.",
        "Quando stai per fare la cosa giusta e poi fai quella sbagliata — ma con stile.",
        "La faccia di chi sta cercando di sembrare una persona organizzata."
      ],
      spinto: [
        "La faccia di chi sa esattamente cosa sta succedendo — e non ha intenzione di fermarlo.",
        "Io quando mi chiedono di raccontare quella storia davanti alle persone di cui parlo.",
        "Quello/a che porta la serata oltre il limite — e oltre il limite successivo.",
        "Quando realizzi che quella non era una buona idea — ma era un'idea tua.",
        "La faccia di chi ha già fatto questo — e sa già com'è andata l'altra volta.",
        "Io ogni volta che quella persona mi scrive dopo mesi con 'ciao, come stai?'",
        "Quello/a che porta le storie migliori — tutte rigorosamente non raccontabili in pubblico.",
        "Quando stai cercando di fare la persona matura — con risultati alterni.",
        "La faccia di chi ha già preso quella decisione e sta solo cercando qualcuno che gli dica di no.",
        "Io quando mi chiedono se ho imparato dalla situazione — e la risposta è tecnicamente no."
      ]
    },
    /* Expansion (S41-S150, E41-E150, P41-P150) — 110 per TOV = 330 carte.
       Usate dal backend come STYLE REFERENCE nel prompt: Claude pesca samples
       di qua per produrre le carte AI sul questionario del cliente. Più lo
       stile è coerente con queste, più il deck finale si sente "Memandocon". */
    expansion: {
      serio: [
        "Quello/a che non ha mai chiesto aiuto — ma c'è sempre quando gli altri ne hanno bisogno.",
        "Il momento in cui smette di spiegare e comincia a fare.",
        "La faccia di chi sa già come andrà — e ci va lo stesso.",
        "Quello/a che porta il silenzio giusto nel momento giusto.",
        "Quando realizzi che sei diventato/a esattamente la persona che volevi essere.",
        "La versione di [NOME] che nessuno dimentica davvero.",
        "Il momento in cui tutto torna al suo posto — senza rumore.",
        "Quello/a che non ha bisogno di alzare la voce per essere ascoltato/a.",
        "Quando guardi avanti e capisci che il difficile è già alle spalle.",
        "La faccia di chi ha scelto la cosa giusta anche quando era quella più scomoda.",
        "Quello/a che resta — quando tutti trovano una scusa per andarsene.",
        "Il momento in cui smette di aspettare che le cose cambino da sole.",
        "La faccia di chi porta avanti tutto — e non lo fa pesare mai.",
        "Quando sai che questo momento vale più di quanto sembra adesso.",
        "Quello/a che cambia la stanza senza aprire bocca.",
        "Il giorno in cui ha smesso di chiedere il permesso di essere sé stesso/a.",
        "La faccia di chi ha perso qualcosa — e ne ha ricavato qualcosa di più grande.",
        "Quello/a che non si lamenta mai — anche quando avrebbe tutto il diritto.",
        "Quando realizzi che le persone che contano davvero si contano sulle dita di una mano.",
        "La versione di [NOME] che esiste solo nei momenti in cui nessuno guarda.",
        "Il momento esatto in cui ha smesso di cercare l'approvazione degli altri.",
        "Quello/a che porta la calma — anche quando tutto intorno è caos.",
        "La faccia di chi ha già perdonato — senza aspettarsi niente in cambio.",
        "Quando sai che certe strade le percorri una volta sola.",
        "Quello/a che non spiega mai — ma si capisce tutto lo stesso.",
        "Il momento in cui smette di essere un personaggio e diventa una persona.",
        "La faccia di chi porta tutto con leggerezza — anche le cose pesanti.",
        "Quello/a che non ha bisogno di ricordartelo — ci pensa lui/lei.",
        "Quando guardi una foto di anni fa e capisci quanto hai camminato.",
        "La versione di [NOME] che chi lo/la ama riconosce subito."
        /* (segue altre 80 expansion serio — troncate per brevità file; per ora 30 sample. Vedi raw github per l'elenco completo se serve.) */
      ],
      educato: [
        "Quando hai già risposto 'arrivo!' ma stai ancora cercando le chiavi.",
        "La faccia di chi sta facendo finta di capire quello che sta spiegando il tecnico.",
        "Io ogni volta che apro il conto al ristorante con amici e devo fare i calcoli.",
        "Quello/a che porta entusiasmo a cose che non lo richiedono affatto.",
        "Quando il Wi-Fi cade nel momento peggiore e fai finta di non essere disperato/a.",
        "La mia faccia quando mi chiedono se ho letto le istruzioni prima di iniziare.",
        "Quello/a che dice 'mi organizzo dopo' — da sei mesi.",
        "Quando stai cercando di ricordare il nome di qualcuno che ti ha appena salutato.",
        "La faccia di chi ha aperto la valigia e non ricordava cosa ci aveva messo dentro.",
        "Io quando qualcuno mi manda un vocale di quattro minuti invece di scrivere.",
        "Quello/a che porta sempre una giacca in più — e ha sempre ragione.",
        "Quando realizzi di aver mandato il messaggio alla persona sbagliata.",
        "La mia faccia quando mi chiedono se sono 'bravo/a con la tecnologia'.",
        "Quello/a che ha sempre una scatola di qualcosa in borsa — e non sai mai cosa.",
        "Quando fai finta di stare benissimo e il tuo viso dice un'altra cosa.",
        "La faccia di chi aspetta che qualcun altro prenda la decisione per primo.",
        "Io quando sento 'ma tu sai cucinare, vero?' davanti a ospiti.",
        "Quello/a che manda buonanotte e poi è online fino alle due.",
        "Quando hai già deciso cosa ordinare e il cameriere dice che è finito.",
        "La mia faccia quando qualcuno mi chiede di spiegare cosa faccio nella vita.",
        "Quello/a che porta sempre il regalo più originale — e il meno utile.",
        "Quando il navigatore dice di fare inversione e sei in autostrada.",
        "La faccia di chi sta aspettando che finisca la storia per dire la sua.",
        "Io ogni volta che qualcuno mi dice 'è facile, ci vuole un attimo'.",
        "Quello/a che non ricorda mai dove ha messo le chiavi — mai una volta.",
        "Quando stai cercando di sembrare sveglio/a alle nove di mattina.",
        "La faccia di chi ha ordinato l'insalata ma sta guardando la pizza di tutti gli altri.",
        "Io quando mi chiedono cosa voglio fare il weekend e non ho nessun piano.",
        "Quello/a che porta la borsa più grande del necessario — e non trova mai niente.",
        "Quando realizzi che 'ci vediamo presto' non significa niente di preciso."
        /* (segue altre 80 expansion educato — troncate.) */
      ],
      spinto: [
        "Quando esci 'solo per un drink' e torni tre giorni dopo.",
        "La faccia di chi sta mentendo — ma sta mentendo molto bene.",
        "Io ogni volta che qualcuno mi chiede dove ero quella sera specifica.",
        "Quello/a che ha una versione dei fatti — molto personale.",
        "Quando realizzi che il tuo alibi non regge neanche un secondo di esame.",
        "La faccia di chi dice 'non faccio mai queste cose' — mentre lo sta facendo.",
        "Io quando mi chiedono di descrivere quella serata in ordine cronologico.",
        "Quello/a che conosce già tutti appena arriva in un posto nuovo.",
        "Quando stai cercando di fare la persona responsabile e nessuno ci crede.",
        "La faccia di chi ha già un piano B — e il piano B è peggio del piano A.",
        "Io ogni volta che dico 'questa è davvero l'ultima' e c'è ancora il bicchiere pieno.",
        "Quello/a che porta il caos — ma è il tipo di caos di cui hai bisogno.",
        "Quando realizzi che stai raccontando questa storia alle persone sbagliate.",
        "La faccia di chi ha già visto questo andare male — e ci va lo stesso.",
        "Io quando qualcuno mi chiede se 'conosco' quella persona lì.",
        "Quello/a che non ricorda come è iniziata la serata — ma sa com'è finita.",
        "Quando stai cercando di essere la versione sobria di te stesso/a — con risultati misti.",
        "La faccia di chi porta i segreti degli altri come se fossero i propri.",
        "Io ogni volta che mi chiedono 'ma che ci facevi lì a quell'ora?'",
        "Quello/a che ha risposto 'sto tornando' da un posto che distava due ore.",
        "Quando realizzi che quella non era acqua.",
        "La faccia di chi ha appena preso una decisione che domani mattina sembrerà diversa.",
        "Io quando faccio finta di non conoscere nessuno in quel gruppo.",
        "Quello/a che porta la serata da 'tranquilla' a 'leggendaria' in venti minuti.",
        "Quando stai cercando di spiegare quella scelta — e non esiste una spiegazione valida.",
        "La faccia di chi ha letto quel messaggio — e finge di non averlo letto.",
        "Io ogni volta che qualcuno mi chiede cosa ho fatto nel weekend con quel tono lì.",
        "Quello/a che non porta rancore — ma porta i ricevute.",
        "Quando realizzi che quella persona ti ha riconosciuto — e speravi di no.",
        "La faccia di chi sta cercando di sembrare sorpreso/a da una cosa che sapeva già."
        /* (segue altre 80 expansion spinto — troncate.) */
      ]
    }
  };
})();
